<template>
<div class="chapter">
<div class="inner_page">
<p class="image-center"><span><img alt="image" class="svg1" src="images/002.Intro.Mirror.jpg"/></span></p>
<p class="caption"><span>Jack Robinson/©The Jack Robinson Archive</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter01.vue?3957e1c2